<template>
  <div class="PaidMemberChange">
    <section-header heading="2" ja="クレジットカード登録変更/解約" />
    <div class="description">
        クレジットカードの変更を行う場合は「クレジットカードを変更する」のボタンを押してください。<br>
        ※変更のお手続きが完了するまでの間は、変更前のクレジットカードでのお支払いとなります。
    </div>
    <normal-btn @click="onChange">クレジットカードを変更する</normal-btn>
    <form enctype="application/json" method="post" :action="url" ref="form">
      <input type="hidden" name="accessToken" :value="accessToken"/>
    </form>
    <sub-btn  @click="onPaidMemberRemoval">有料会員解約はこちら</sub-btn>
  </div>
</template>

<script>
import SectionHeader from "../components/SectionHeader"
import NormalBtn from "../components/NormalBtn"
import SubBtn from "../components/SubBtn"
import Protobuf from '../mixins/protobuf'

const pb = require('../assets/js/kumaproto').kuma.jp.protobuf.web

export default {
  name: "PaidMemberChange",
  components: {
    SectionHeader,
    NormalBtn,
    SubBtn
  },
  mixins: [Protobuf],
  data() {
    return {
      url: '',
      accessToken: ''
    }
  },
  methods: {
    onChange() {
      this.setCreditCardForm(() => this.$nextTick(() => this.$refs['form'].submit()))
    },
    onPaidMemberRemoval() {
      this.$router.push('/paidMemberRemoval2')
    },
    setCreditCardForm(callback) {
      const cmdNo = pb.BuyCardUpdateReq.CommandNo.COMMAND_NO
      const message = pb.BuyCardUpdateReq.create()
      const encoded = pb.BuyCardUpdateReq.encode(message).finish()
      this.post(cmdNo, encoded)
        .then(decoded => {
          if (decoded.status === 0) {
            this.url = decoded.url
            const json = JSON.parse(decoded.postJson)
            this.accessToken = json.accessToken
            callback()
          } else {
            this.$_error('Error', { title: 'クレジットカード登録変更', statusCode: 100 })
          }
        })
        .catch(() => {
          this.$_error('Error', { title: 'クレジットカード登録変更', statusCode: 100 })
        })
    }
  }
}
</script>

<style scoped>
.description {
  color: #373737;
  font-size: 12px;
  margin: 30px 30px 0;
}
</style>
